import React, { Component, PropTypes } from 'react'
import { Metrics, Colors, Fonts } from '../../Themes'
import styled from 'styled-components'
import Arrow from '../../svg-icons/Arrow'

const Label = styled.div`
  ${Fonts.style.Text};
  margin-top: ${Metrics.margins.base};
  cursor: pointer;
  display: inline-block;
`

const ArrowContainer = styled.div`
  width: 30px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  svg {
    position: absolute;
    top: -16px;
    right: 0px;
    transform: ${props => (props.isActive ? 'rotate(0deg)' : 'rotate(180deg)')};
    fill: ${Colors.primary};
  }
`

const DropdownBox = styled.div`
  display: ${props => (props.isActive ? 'block' : 'none')};
  position: absolute;
  top: ${props => (props.isMoreFilters ? '0px' : '58px')};
  left: -1px;
  border: ${props => (props.isMoreFilters ? 'none' : Metrics.borders.default)};
  background: ${Colors.white};
  min-width: 260px;
  z-index: 2;
  padding: ${props =>
    props.isMoreFilters || props.dropdown ? 0 : Metrics.margins.small};
  .dropdown-component {
    ${props => props.dropdown && 'padding: 0'};
    ${props => props.dropdown && 'width: calc(100% - 2px)'};
  }
  .dropdown-header {
    padding-top: ${props => (props.isMoreFilters ? 0 : Metrics.margins.small)};
    padding-left: ${props => (props.isMoreFilters ? 0 : Metrics.margins.small)};
  }

  .tags {
    ${props => props.dropdown && `margin-left: ${Metrics.margins.small}`};
  }
`

const DropdownContainer = styled.div`
  display: ${props => (props.isMoreFilters ? 'inline' : 'inline-block')};
  padding: 0 ${Metrics.margins.small};
  border-right: ${Metrics.borders.default};
  background: ${props =>
    props.isMoreFilters && props.isActive ? 'transparent' : Colors.white};
  z-index: 3;
  position: ${props => (props.isMoreFilters ? 'static' : 'relative')};
  height: 100%;
  cursor: pointer;
  border-bottom: ${props => {
    if (!props.isActive && props.active === 'More Filters') {
      return Metrics.borders.default
    }
    if (props.isActive) {
      return Metrics.borders.defaultOrange
    } else {
      return 'none'
    }
  }};
  .dropdown-button {
    background: transparent;
    border: none;
    position: ${props =>
      props.isMoreFilters && props.isActive ? 'absolute' : 'inherit'};
    z-index: ${props =>
      props.isMoreFilters && props.isActive ? 3 : 'inherit'};
  }
`

class SearchDropdown extends Component {
  render () {
    let { id, active, onBlur, onFocus, onClick, dropdown } = this.props
    let isActive = id === active
    let isMoreFilters = isActive && id === 'More Filters'
    return (
      <DropdownContainer
        isMoreFilters={isMoreFilters}
        isActive={isActive}
        active={active}>
        <button
          className='dropdown-button'
          onFocus={onFocus}
          onBlur={onBlur}
          id={`button-${id}`}
          onClick={() => onClick(id)}>
          <Label>{id}</Label>
          <ArrowContainer>
            <Arrow />
          </ArrowContainer>
        </button>
        <DropdownBox
          id={id}
          tabIndex={'-1'}
          onFocus={onFocus}
          onBlur={onBlur}
          isMoreFilters={isMoreFilters}
          isActive={isActive}
          dropdown={dropdown}>
          {this.props.children}
        </DropdownBox>
      </DropdownContainer>
    )
  }
}

SearchDropdown.propTypes = {
  active: PropTypes.string,
  id: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  dropdown: PropTypes.bool
}

export default SearchDropdown



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchDropdown.js